import type { ProjectStepId } from "./projectNavigation";

/** What an empty step page says, and the name of its Generate button. */
export interface StepGenerateCopy {
  title: string;
  /** One sentence on what RivetAI builds. */
  description: string;
  /** Names the action, e.g. "Generate schedule". */
  actionLabel: string;
}

/**
 * Empty-page copy per production step. Every button uses one verb,
 * "Generate", plus the noun of its row in the Run AI dialog ("Script
 * breakdown", "Character breakdown", "Coverage", "Schedule", "Budget"),
 * so the user recognizes the row the button opens.
 */
export const PROJECT_STEP_GENERATE_COPY: Record<ProjectStepId, StepGenerateCopy> = {
  script: {
    title: "No breakdown yet",
    description:
      "RivetAI tags cast, props, locations and more in every scene. Schedule and budget use these tags, and you can edit them after.",
    actionLabel: "Generate script breakdown",
  },
  characters: {
    title: "No characters yet",
    description:
      "RivetAI builds the character list and dialogue context from your script. You can edit everything after.",
    actionLabel: "Generate character breakdown",
  },
  schedule: {
    title: "No schedule yet",
    description:
      "RivetAI builds the stripboard, day breaks and Day Out of Days from your script and cast. You can edit everything after.",
    actionLabel: "Generate schedule",
  },
  budget: {
    title: "No budget yet",
    description:
      "RivetAI estimates line items, fringes and totals from your script tags and assumptions. You can edit everything after.",
    actionLabel: "Generate budget",
  },
};

/** Coverage is a Script page with its own pipeline. */
export const COVERAGE_GENERATE_COPY: StepGenerateCopy = {
  title: "No coverage report yet",
  description:
    "RivetAI reads your script and writes rubric scores, a synopsis and reader analysis you can share.",
  actionLabel: "Generate coverage",
};

/** Under every Generate button. The Run AI dialog shows the price before anything runs. */
export const GENERATE_COST_NOTE = "Uses AI credits. You see the cost before it runs.";
